export class UserInvestigate {
    name;
    phone;
    area = new Area();
    address;
    areaStr;
    constructor() { }
}

export class Area {
    province;
    city;
    country;
    constructor() { }
}